<template>
  <div class="p-search-modal__tab-content">
    <div v-if="movieType" class="p-search-modal__tab-content__movies">
      <MovieHorizontalCard
        v-for="movie in movieResult"
        :key="movie.id"
        class="b-movie-horizontal-card"
        :translated="movie.transl"
        :movie-id="movie.id"
        :show-book-button="movie.movieId !== ''"
        :movie-url="movie.url"
        :title="movie.title"
        :description="movie.desc"
        :image="movie.thumb"
        :pg="movie.pg"
        :duration="movie.dur"
        :genres="recordGenres(movie.genres)"
        :dictionary="dictionary"
        :sub-title="movie.subTitle"
        :dolby="movie.dolby"
        :sphera="false"
        :three-dimensions="movie.threeDimensions"
        :imax="movie.imax" />

      <MovieSearchResultMobile
        v-for="movie in movieResult"
        :key="`mob-${movie.id}`"
        :translated="movie.transl"
        :movie-url="movie.url"
        :translatable-text="dictionary.translatable"
        :image="movie.thumb"
        :title="movie.title"
        :sub-title="movie.subTitle" />
    </div>
    <div v-else>
      <ArticleCard
        v-for="article in articleResult"
        :key="article.id"
        :image="article.image"
        :title="article.title"
        :description="article.desc"
        :url="article.url"
        class="mb-2" />
    </div>
  </div>
</template>

<script setup>
import ArticleCard from '../ArticleCard.vue'
import MovieHorizontalCard from '../MovieHorizontalCard.vue'
import MovieSearchResultMobile from '../UI/MovieSearchResultMobile.vue'
import { getData, getRecordGenres } from '../../../lib/lib'
import { computed } from 'vue'
const { filters } = getData('searchModalData')
const allGenres = filters?.genres

const props = defineProps({
  currentActiveResult: { default: 'movie', type: String },
  movieResult: {
    default: () => {
      return []
    },
    type: Array,
  },
  articleResult: {
    default: () => {
      return []
    },
    type: Array,
  },
  dictionary: {
    default: () => {
      return []
    },
    type: Object,
  },
  configuration: {
    default: () => {
      return []
    },
    type: Object,
  },
})

const movieType = computed(() => {
  return props.currentActiveResult === 'movie'
})

const recordGenres = (genres) => {
  if (genres) {
    return getRecordGenres(genres, allGenres)
  }
}
</script>
